import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Shoes Guide',
    slug: '/pandabuy-spreadsheet-shoes',
    desc: 'Best sneaker finds from Jordans to Dunks, curated for quality and style.',
    image: 'https://readdy.ai/api/search-image?query=A%20stunning%20close-up%20of%20limited%20edition%20sneakers%20with%20unique%20colorway%20on%20a%20clean%20white%20surface%2C%20bright%20studio%20lighting%2C%20product%20photography%20with%20vibrant%20colors%20and%20sharp%20details&width=600&height=400&seq=homeart-shoes-032&orientation=landscape',
  },
  {
    title: 'Hoodies Guide',
    slug: '/pandabuy-spreadsheet-hoodies',
    desc: 'Essentials, vintage fleece, and streetwear hoodies for every season.',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20hoodie%20in%20warm%20terracotta%20tone%20draped%20on%20a%20minimalist%20chair%2C%20soft%20evening%20light%2C%20lifestyle%20interior%20photography%20with%20comfortable%20aesthetic&width=600&height=400&seq=homeart-hoodies-033&orientation=landscape',
  },
  {
    title: 'T-Shirts Guide',
    slug: '/pandabuy-spreadsheet-tshirts',
    desc: 'Vintage graphics, premium basics, and statement tees verified and rated.',
    image: 'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20colorful%20vintage%20style%20graphic%20t-shirts%20with%20retro%20designs%20on%20a%20textured%20cream%20surface%2C%20bright%20natural%20light%2C%20playful%20editorial%20composition&width=600&height=400&seq=homeart-tshirt-034&orientation=landscape',
  },
  {
    title: 'Jackets Guide',
    slug: '/pandabuy-spreadsheet-jackets',
    desc: 'Bombers, varsity, denim and technical outerwear for every occasion.',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20varsity%20jacket%20with%20bold%20patches%20hung%20on%20a%20brick%20wall%2C%20urban%20editorial%20fashion%20photography%20with%20dramatic%20side%20lighting%2C%20streetwear%20aesthetic&width=600&height=400&seq=homeart-jackets-035&orientation=landscape',
  },
  {
    title: 'Accessories Guide',
    slug: '/pandabuy-spreadsheet-accessories',
    desc: 'Sunglasses, watches, jewelry and more to complete your look.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20minimalist%20jewelry%20and%20a%20classic%20watch%20on%20a%20white%20marble%20surface%20with%20soft%20shadows%2C%20luxury%20product%20photography%2C%20refined%20composition&width=600&height=400&seq=homeart-accessories-036&orientation=landscape',
  },
  {
    title: 'Bags Guide',
    slug: '/pandabuy-spreadsheet-bags',
    desc: 'Totes, backpacks and crossbody bags curated for durability and style.',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20canvas%20tote%20bag%20and%20leather%20backpack%20displayed%20on%20a%20light%20wooden%20table%2C%20warm%20sunlight%2C%20lifestyle%20product%20photography%20with%20organic%20elements&width=600&height=400&seq=homeart-bags-037&orientation=landscape',
  },
  {
    title: '2026 Trends',
    slug: '/pandabuy-spreadsheet-trends',
    desc: 'Stay ahead with the hottest fashion trends dominating the spreadsheet scene.',
    image: 'https://readdy.ai/api/search-image?query=A%20fashion-forward%20display%20of%20trending%20earth%20tone%20clothing%20and%20accessories%20arranged%20on%20minimalist%20shelves%2C%20editorial%20style%2C%20warm%20lighting%2C%20contemporary%20fashion%20photography&width=600&height=400&seq=homeart-trends-038&orientation=landscape',
  },
  {
    title: 'Safety Tips',
    slug: '/pandabuy-spreadsheet-safety',
    desc: 'Shop smart with our essential safety guide for spreadsheet-based shopping.',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20photograph%20of%20a%20shopping%20cart%20with%20a%20shield%20symbol%20on%20a%20white%20background%2C%20conceptual%20online%20shopping%20safety%20photography%2C%20bright%20clean%20composition&width=600&height=400&seq=homeart-safety-039&orientation=landscape',
  },
  {
    title: 'Beginners Guide',
    slug: '/pandabuy-spreadsheet-beginners',
    desc: 'New to spreadsheet shopping? Start here with our friendly beginner guide.',
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20desk%20setup%20with%20a%20laptop%20displaying%20an%20organized%20spreadsheet%20next%20to%20a%20cup%20of%20coffee%2C%20morning%20sunlight%2C%20friendly%20lifestyle%20photography%20with%20plants&width=600&height=400&seq=homeart-beginner-040&orientation=landscape',
  },
];

export default function ArticlesSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-5">
            Learn More
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight text-balance">
            PandabuySpreadsheet <span className="italic text-primary-500">Guides & Articles</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            Dive deeper with our collection of SEO-optimized guides covering every aspect of pandabuyspreadsheet shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                  {article.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                  Read Article <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/pandabuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            <span>View Complete Shopping Guide</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}